export enum TaxApplicable {
  /** Tax exempted e.g. Tax W9 (https://www.irs.gov/pub/irs-pdf/fw9.pdf) */
  exempted = 0,
  /** Custom tax applies where client form provides the tax information */
  custom = 1,
  /** Default Tax applies, where tax information DB is used */
  default = 2
}